import RiskWarning from "../components/RiskWarning";
import CTASection from "../components/CTASection";
import { COMPLIANCE_DATA, TAGLINE_MF, TAGLINE_SIF } from "../constants/compliance";

export default function About() {
  return (
    <div id="main-content" className="pt-20" data-testid="about-page">
      <section className="py-32 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-8 text-gray-100" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
            About Kredere Family Office
          </h1>
          
          <div className="space-y-8 text-gray-300">
            <div className="p-6 bg-[#0f0f0f] border border-gray-800 rounded-lg" data-testid="compliance-section">
              <h2 className="text-2xl font-semibold mb-4 text-[#d4af69]">Compliance Information</h2>
              
              <div className="space-y-3 text-sm">
                <div>
                  <span className="font-medium text-gray-200">Legal Entity Name:</span>
                  <p className="text-gray-400">{COMPLIANCE_DATA.legalName}</p>
                </div>
                <div>
                  <span className="font-medium text-gray-200">Trade Name:</span>
                  <p className="text-gray-400">{COMPLIANCE_DATA.tradeName}</p>
                </div>
                <div>
                  <span className="font-medium text-gray-200">ARN:</span>
                  <p className="text-gray-400">{COMPLIANCE_DATA.arn}</p>
                </div>
                <div>
                  <span className="font-medium text-gray-200">Registration Status:</span>
                  <div className="space-y-1 mt-1">
                    <p className="text-gray-400">• {TAGLINE_MF}</p>
                    {COMPLIANCE_DATA.sifEnabled && (
                      <p className="text-gray-400">• {TAGLINE_SIF}</p>
                    )}
                  </div>
                </div>
                <div>
                  <span className="font-medium text-gray-200">Registered Address:</span>
                  <p className="text-gray-400">{COMPLIANCE_DATA.address}</p>
                </div>
              </div>
            </div>

            <div className="p-6 bg-[#0f0f0f] border border-gray-800 rounded-lg" data-testid="role-clarification">
              <h2 className="text-2xl font-semibold mb-4 text-[#d4af69]">Our Role</h2>
              <p className="text-gray-400">
                We are a distributor of mutual fund and SIF products. <strong className="text-gray-200">We do not provide investment advisory services</strong> unless separately registered.
              </p>
            </div>

            <div className="p-6 bg-[#0f0f0f] border border-gray-800 rounded-lg" data-testid="services-overview">
              <h2 className="text-2xl font-semibold mb-4 text-[#d4af69]">What We Do</h2>
              <p className="text-gray-400 mb-4">
                Kredere Family Office specializes in the distribution of:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-400 ml-4">
                <li>Mutual Fund products across various categories</li>
                <li>Specialized Investment Funds (SIF) for eligible investors</li>
              </ul>
            </div>

            <CTASection />

            <RiskWarning />
          </div>
        </div>
      </section>
    </div>
  );
}